import "@babel/polyfill"

export function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    && !window.MSStream;
}

export async function load_scripts(items) {
  await Promise.all(items.map(async function (item) {
    return await load_script(item)
  }))
}

export async function load_script(str) {
  if (is_valid_url(str)) return await load_js_script(str)
  var url = build_url(str)
  if (url) await  load_js_script(url)
} 

export function is_valid_url(str) {
  var a  = document.createElement('a');
  a.href = str;
  return (a.host && a.host != window.location.host);
}

function load_js_script(url) {
  return new Promise(function (resolve, reject) {
    
    var scr = document.createElement('script')
    scr.src = url
    scr.onload = resolve
    scr.onreadystatechange = resolve
    scr.onerror = reject
  
    document.head.appendChild(scr);
  })
}

function build_url(plugin) {
  var base_url = get_base_url()
  if (!base_url) return console.error("error: flowplayer.js not found from the page")
  return base_url + "plugins/" + plugin + ".min.js"
}

function get_base_url() {
  var scripts = document.scripts
  for (var i = 0; i < scripts.length; ++i) {
    var scr_url = scripts[i].src  
    var base = scr_url.match(/(.*\/releases\/native\/.*\/)flowplayer.*.js/)
    if (base && base.length > 0) return base[1]
  }
  return null
}
